import GoogleTagManager from './GoogleTagManager';

export const GTM = new GoogleTagManager();
